setTimeout(function() {
  var shuffled = products.sort(() => 0.5 - Math.random()); // 商品リストをランダムにシャッフル
  var selectedProducts = shuffled.slice(0, 2); // 最初の2つの商品を選択

  // ランダムな商品をHTMLに挿入
  var product1 = document.getElementById("product-1");
  var product2 = document.getElementById("product-2");

  // 商品名の後ろから10文字を削除
  var truncatedTitle1 = selectedProducts[0].title.slice(0, selectedProducts[0].title.length - 10);
  var truncatedTitle2 = selectedProducts[1].title.slice(0, selectedProducts[1].title.length - 10);

  product1.innerHTML = `
    <a href="${selectedProducts[0].url}" style="text-decoration: none;">
      <img src="${selectedProducts[0].image}" alt="${selectedProducts[0].title}" style="width: 100%;">
      <p style="font-size:1rem; font-family: var(--font-heading-family); color:#121212BF; margin-bottom:0;">${selectedProducts[0].vendor}</p>
      <p style="font-size:1.2rem; font-family: var(--font-heading-family); font-weight:400; color:black; margin-top:0;">${truncatedTitle1}</p>
      <div class="price">
        <div class="price__regular">
          <span class="visually-hidden visually-hidden--inline">通常価格</span>
          <span class="price-item price-item--regular">
            <span class="notranslate ht-money">¥${selectedProducts[0].price}</span>
            <span class="tax-included"></span>
          </span>
        </div>
      </div>
    </a>
  `;

  product2.innerHTML = `
    <a href="${selectedProducts[1].url}" style="text-decoration: none;">
      <img src="${selectedProducts[1].image}" alt="${selectedProducts[1].title}" style="width: 100%;">
      <p style="font-size:1rem; font-family: var(--font-heading-family); color:#121212BF; margin-bottom:0;">${selectedProducts[1].vendor}</p>
      <p style="font-size:1.2rem; font-family: var(--font-heading-family); font-weight:400; color:black; margin-top:0;">${truncatedTitle2}</p>
      <div class="price">
        <div class="price__regular">
          <span class="visually-hidden visually-hidden--inline">通常価格</span>
          <span class="price-item price-item--regular">
            <span class="notranslate ht-money">¥${selectedProducts[1].price}</span>
            <span class="tax-included"></span>
          </span>
        </div>
      </div>
    </a>
  `;
}, 1500);